import axios from "axios";

export const publicRequest = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const userRequest = (accessToken) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { token: `Bearer ${accessToken}` },
  });
};

export const userFormRequest = (accessToken) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      token: `Bearer ${accessToken}`,
      "content-type": "multipart/form-data",
      boundary: "&",
    },
  });
};
